import peopleReducer from "./reducers";
export { default as peopleTypes } from "./types";
export { default as peopleOperations } from "./operations";
export default peopleReducer;
